import { render, staticRenderFns } from "./EmpresaCnpjSelect.vue?vue&type=template&id=97103d52&scoped=true"
import script from "./EmpresaCnpjSelect.vue?vue&type=script&lang=js"
export * from "./EmpresaCnpjSelect.vue?vue&type=script&lang=js"
import style0 from "./EmpresaCnpjSelect.vue?vue&type=style&index=0&id=97103d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97103d52",
  null
  
)

export default component.exports